import Bakım from '../assets/bakım.png'
import Bakım1 from '../assets/bakim1.png'
import Bakım2 from '../assets/photo.jpeg'
import Bakım3 from '../assets/rapor.jpg'
import Bakım4 from '../assets/bot.png'

export const getServiceList = (t) => [
  {
    name: t('serviceList.s1.name'),
    image: Bakım3,
    aciklama: [
      t('serviceList.s1.p1'),
      t('serviceList.s1.p2'),
      t('serviceList.s1.p3'),
      t('serviceList.s1.p4'),
      t('serviceList.s1.p5'),
      t('serviceList.s1.p6'),
      t('serviceList.s1.p7'),
      t('serviceList.s1.p8'),
      t('serviceList.s1.p9'),
      t('serviceList.s1.p10'),
      t('serviceList.s1.p11'),
      t('serviceList.s1.p12'),
    ]
  },
  {
    name: t('serviceList.s2.name'),
    image: Bakım,
    aciklama: t('serviceList.s2.desc'),
  },
  {
    name: t('serviceList.s3.name'),
    image: Bakım1,
    aciklama: t('serviceList.s3.desc'),
  },
  {
    name: t('serviceList.s4.name'),
    image: Bakım2,
    aciklama: t('serviceList.s4.desc'),
  },

];

export default getServiceList;